import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

import BackButton from "./back-button";
import { TextMenuItem } from "./types";

export default function TextOptionsPanel({
  menuItem,
  selected,
  onSelectionChange,
  onBack,
}: {
  menuItem: TextMenuItem;
  selected: string[];
  onSelectionChange: (values: string[]) => void;
  onBack: () => void;
}) {
  function toggleValue(value: string) {
    if (selected.includes(value)) {
      onSelectionChange(selected.filter((v) => v !== value));
    } else {
      onSelectionChange([...selected, value]);
    }
  }

  return (
    <div>
      <BackButton label={menuItem.label} onBack={onBack} />
      {menuItem.options.map((option) => {
        const checked = selected.includes(option.value);
        return (
          <DropdownMenu.CheckboxItem
            key={option.value}
            checked={checked}
            onCheckedChange={() => toggleValue(option.value)}
            onSelect={(e) => e.preventDefault()}
            className="flex cursor-pointer select-none items-center gap-3 rounded-md px-3 py-2 text-sm text-gray-700 outline-none hover:bg-primary-50 focus:bg-primary-50 focus:ring-2 focus:ring-primary-500"
          >
            <div
              className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border ${checked ? "border-primary-500 bg-primary-500 text-white" : "border-gray-300"}`}
            >
              {checked && (
                <svg
                  className="h-3 w-3"
                  viewBox="0 0 12 12"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path d="M2 6l3 3 5-5" />
                </svg>
              )}
            </div>
            {option.icon && (
              <span className="flex h-5 w-5 shrink-0 items-center justify-center text-gray-400">
                {option.icon}
              </span>
            )}
            <span className="flex-1">{option.label}</span>
          </DropdownMenu.CheckboxItem>
        );
      })}
    </div>
  );
}
